import React from 'react'
import { useDispatch } from 'react-redux'
import Col from 'muicss/lib/react/col'
import Row from 'muicss/lib/react/row'
import {
  updateCampaign as updateCampaignAction,
} from 'services/ambassador/redux/actions'
import Button from 'muicss/lib/react/button'
import Container from 'muicss/lib/react/container'
import { dismissModal as dismissModalAction } from 'services/modal/redux/actions'

import './index.scss'

/**
 * Modal to remove a partner from a campaign
 *
 * @returns {JSX.Element}
 */
const RemovePartnerModal = (props) => {
  const { uuid, removeAmbassadors } = props
  const dispatch = useDispatch()

  const onDismissHandler = (e) => {
    e.persist()
    dispatch(dismissModalAction())
  }

  const handleSubmit = () => {
    dispatch(updateCampaignAction({ uuid, removeAmbassadors }))
  }

  return (
    <div className="remove-partner-modal">
      <h2 className="remove-partner-modal__title">Are you sure you want to remove this partner from the campaign?</h2>
      <Container fluid={true}>
          <Row>
            <Col sm="12">
              <div className="remove-partner-modal__actions">
              <Button
                variant="raised"
                type="submit"
                onClick={handleSubmit}
              >
                YES, REMOVE
              </Button>
              <Button
                type="button"
                variant="raised"
                color="accent"
                className="mui-btn--secondary"
                onClick={onDismissHandler}
              >
                CANCEL
              </Button>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default (RemovePartnerModal)
